import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Avatar } from '../../components';
import { getUserFullName } from '../../utils/utilsChat';
import styles from './ScheduleSettingsOperatorList.scss';

const mapStateToProps = state => {
  return {
    currentCompanyOperators: state.currentCompanyOperators,
  };
};

@connect(mapStateToProps)
@withRouter
export class ScheduleSettingsOperatorList extends Component {

  render(){
    const {
      match,
      className,
      currentCompanyOperators,
      onSelect,
    } = this.props;

    const { operatorId } = match.params;

    return (
      <ul className={cn(className, styles.container)}>
        <li className={cn({
          [styles.item]: true,
          [styles.itemActive]: operatorId === 'all',
        })}>
          <Link className={styles.link} to="/schedule/all" onClick={onSelect}>
            <i className={cn(styles.avatarAllOperators, 'icon-users')}/>
            Все операторы
          </Link>
        </li>

        {currentCompanyOperators.map(operator => (
          <li key={operator.id} className={cn({
            [styles.item]: true,
            [styles.itemActive]: operatorId === operator.id,
          })}>
            <Link className={styles.link} to={`/schedule/${operator.id}`} onClick={onSelect}>
              <Avatar className={styles.avatar} user={operator}/>
              {getUserFullName(operator)}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}
